import vue from 'vue'
import store from './../store/index'

export const filterResponse = response => {
    return new Promise( ( resolve, reject ) => {
        if ( [ 200, 201 ].includes( response.status ) ) {
            return response.json().then( data => {
                if ( data.status === 'error' ) {
                    reject( data )
                }
                resolve( data )
            } )
        } else {
            return response.json().then( data => {
                reject( data )
            } )
        }
    } )
}

export const filterErrors = response => {
    try {
        if ( response.body !== undefined ) {
            let dataResponse = response.body.response;
            if ( [ 401 ].includes( response.status ) && dataResponse.message !== "Invalid details entered" ) { //jwt user auth expired
                let tokenData = {
                    token: null
                };
                store.dispatch( 'saveToken', tokenData )
                store.dispatch( 'redirect', 'login' )
                vue.swal.close()
            }
            if ( [ 403 ].includes( response.status ) && dataResponse.data !== undefined && dataResponse.data !== null ) { //jwt browser auth expired
                if ( dataResponse.data.phoneVerificationRequired !== undefined && dataResponse.data.phoneVerificationRequired === true ) {
                    let tokenData = {
                        browserAuthToken: null,
                        ...dataResponse.data
                    };
                    store.dispatch( 'saveToken', tokenData )
                    store.dispatch( 'redirect', 'verify' )
                    vue.swal.close()
                }
            }
            // if ( dataResponse.message !== "jwt expired" ) {
            return new Promise( ( resolve, reject ) => {
                reject( dataResponse )
            } )
            // }
        }
    } catch ( e ) {
        console.log( 'error from client', e )
        vue.swal( {
            imageUrl: "/images/svg/Error.svg",
            allowEscapeKey: true,
            showConfirmButton: false,
            allowOutsideClick: true,
            showCancelButton: true,
            cancelButtonColor: '#f33',
            cancelButtonText: 'OK',
            title: "Check your Internet Connection."
        } )
    }
}
